<div class="ax-toggle-button__container" [ngClass]="setContainerClasses()" (click)="checkedChange()" [tabIndex]="tabIndex">
    <div class="ax-toggle-button__toggle" [ngClass]="isChecked ? 'ax-toggle-button__toggle--checked' : ''">
        @if (isChecked) {
            <i class="fa-regular fa-check"></i>
        } @else {
            <i class="fa-regular fa-xmark"></i>
        }
    </div>
</div>
